<div class="personnel-infos">
  @if (photoData != null) {
    <div class="photo-part">
      <img [src]="photoData" alt="photo">
    </div>
  }
  <div class="infos-part">
    <div class="nomprenom">{{personnel?.etatCivil?.nom}} {{personnel?.etatCivil?.prenom}}</div>
  </div>
</div>